import React from 'react'
import PropTypes from 'prop-types'

import BusinessSection from '@/business-section'
import Icon from '@/icons'
import LargeText from '@/large-text'

import SectionRevenueImg from './section-revenue-img'

const SectionRevenue = ({ data, gray, isSimple }) => {
  return (
    <BusinessSection
      title="New Revenue Streams"
      subtitle={isSimple ? '' : 'Let consumers buy extra votes & bring sponsors to your votes'}
      topGreen
      gray={gray}
    >
      <div className="flex flex-wrap justify-center mh--3 mb4">
        <SectionRevenueImg
          sizes={data.revenueImg1.sizes}
          icon="three-stars"
          iconText="Paid votes"
          number={isSimple ? '' : <Icon icon="starFilled" size="60%" />}
          numberText="Let your audience buy extra vote packages and share your contest"
        />

        <SectionRevenueImg
          sizes={data.revenueImg2.sizes}
          icon="batman"
          iconText="Branded Buttons"
          number={isSimple ? '' : <span className="f4 fw5">1</span>}
          numberText="Brand the voting button let your audience vote by touching your brand"
        />

        <SectionRevenueImg
          sizes={data.revenueImg3.sizes}
          icon="play-circle"
          iconText="Video ads"
          number={isSimple ? '' : <span className="f4 fw5">2</span>}
          numberText="Then your audience will automatically see a 15sec commercial"
        />

        <SectionRevenueImg
          sizes={data.revenueImg4.sizes}
          icon="lead-capture"
          iconText="Lead Capture"
          number={isSimple ? '' : <span className="f4 fw5">3</span>}
          numberText="While watching the commercial they can fill their contact info to get discounts, win prizes or participate in campaigns"
        />
      </div>

      {isSimple && (
        <div className="mw800 center">
          <LargeText>
            Due to our experience and expertise in the beauty pageant industry, we are specialized in helping our clients with creating new digital revenue streams for their businesses.
        </LargeText>

          <LargeText>
            As we all know, many beauty pageants have large audiences but have yet been unsuccessful to monetize their audience. We have helped hundreds of organisers to successfully create new revenue for their businesses from scratch.
        </LargeText>

          <LargeText>
            Our tailormade turnkey solutions like paid votes, video ads, lead capture and branded buttons help your organisation to generate totally new revenue for you.
        </LargeText>

          <LargeText>
            To get access to our readymade toolkit is easy. Just contact us and we can set up tailored made solutions according to your needs. All features can be live in your digital environment in hours after we have agreed together the best solution for your beauty pageant.
        </LargeText>
        </div>
      )}
    </BusinessSection>
  )
}

SectionRevenue.propTypes = {
  data: PropTypes.object
}

export default SectionRevenue



// WEBPACK FOOTER //
// ./src/components/section-revenue/section-revenue.js